import PropTypes from 'prop-types';

const headerBottomRow = PropTypes.shape({
    imgPathLogo: PropTypes.string,
    src: PropTypes.array,
    body: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool,
});

headerBottomRow.defaultProps = {
    fullWidth: false,
};

export default headerBottomRow;
